import { isEqual } from 'es-toolkit'

// Reference:
// https://gist.github.com/Jezternz/c8e9fafc2c114e079829974e3764db75
function csvStringToArray(data: string) {
  const REG = /(,|\r?\n|\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^,\r\n]*))/gi
  const result: string[][] = [[]]

  while (true) {
    const matches = REG.exec(data)
    if (matches === null) {
      break
    }

    if (matches[1].length && matches[1] !== ',') {
      result.push([])
    }

    result[result.length - 1].push(
      matches[2] !== undefined ? matches[2].replace(/""/g, '"') : matches[3],
    )
  }

  return result
}

export class HeaderMismatchError extends Error {}
export class ColumnsMismatchError extends Error {}
export class MaxmimumExceededError extends Error {}

export interface ParseCsvOption {
  headers?: string[]
}

export function parseCsv(
  csv: string,
  options: ParseCsvOption = {},
): string[][] {
  const parsed = csvStringToArray(csv)

  // remove empty line in file end
  const last = parsed[parsed.length - 1]
  if (last.length === 1 && last[0] === '') {
    parsed.pop()
  }

  verifyData(parsed, options)

  return parsed
}

function verifyData(data: string[][], options: ParseCsvOption): void {
  const { headers } = options
  if (headers && !isEqual(data[0], headers)) {
    throw new HeaderMismatchError()
  }

  if (data.some((row) => row.length !== data[0].length)) {
    throw new ColumnsMismatchError()
  }
}

export function exceedsUserCountCheck(
  newUsersCount: number,
  currentUsersCount: number,
  maximumCount: number,
): void {
  const exceedsUserCount = newUsersCount + currentUsersCount - maximumCount
  if (exceedsUserCount > 0) {
    throw new MaxmimumExceededError(
      `契約人数より${exceedsUserCount}人超過しています`,
    )
  }
}
